module.exports = __webpack_public_path__ + "img/11.3400488e.png";